import { createSlice } from "@reduxjs/toolkit";

const THEME_MODE_KEY = "marketsync_theme_mode";

const loadThemeMode = () => {
  try {
    const saved = localStorage.getItem(THEME_MODE_KEY);
    return saved === "dark" ? "dark" : "light";
  } catch (error) {
    console.error("Error loading theme mode from localStorage:", error);
    return "light";
  }
};

const saveThemeMode = (mode) => {
  try {
    localStorage.setItem(THEME_MODE_KEY, mode);
  } catch (error) {
    console.error("Error saving theme mode to localStorage:", error);
  }
};

const initialState = {
  mode: loadThemeMode(), // 'light' | 'dark' — persists across sessions, independent of auth/logout
};

const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    toggleTheme: (state) => {
      state.mode = state.mode === "dark" ? "light" : "dark";
      saveThemeMode(state.mode);
    },
    setTheme: (state, action) => {
      state.mode = action.payload === "dark" ? "dark" : "light";
      saveThemeMode(state.mode);
    },
  },
});

export const { toggleTheme, setTheme } = uiSlice.actions;
export default uiSlice.reducer;
